import { maybe, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

import type { AiPreviewComparisonResult } from "./types";

export const isAiPreviewComparisonResult = objectOf<AiPreviewComparisonResult>({
  status: number,
  result: maybe(objectOf({ output: string })),
  message: maybe(string),
});
